
import { Vue, Component } from "vue-property-decorator";

@Component({ name: "icon-clock" })
export default class IconClock extends Vue {
  sData: string = require("@icon/feather/clock.svg");
}
